<template>
  <div class="banner">
    <media
      :query="{minWidth: 1081}"
    >
      <div class="banner-pc">
        <a
          class="banner-pc__anchor"
          @click="handleClickBanner"
        >
          <img
            :src="`/theme/rbFront/img/w/case-study/banner/${imgSrc}`"
            class="banner-pc__image"
            :alt="imgAlt"
          >
          <div class="banner-pc__text">
            <div class="banner-pc__text-head">{{ headText }}</div>
            <div
              v-if="title"
              class="banner-pc__text-title"
            >{{ title }}</div>
          </div>
        </a>
      </div>
    </media>
    <media
      :query="{maxWidth: 1080}"
    >
      <div class="banner-mobile">
        <img
          :src="`/theme/rbFront/img/w/case-study/mobile/banner/${imgSrc}`"
          class="banner-mobile__image"
          :alt="imgAlt"
        >
        <a
          class="banner-mobile__anchor"
          @click="handleClickBanner"
        >
          Learn More >
        </a>
      </div>
    </media>
  </div>
</template>

<script>
import Media from 'vue-media'
export default {
  name: 'Banner',
  components: {
    Media,
  },
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
    imgAlt: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    headText: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    ga4Text: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClickBanner() {
      window.dataLayer.push({
        event: 'showroom_entrance',
        click_text: this.ga4Text,
        click_url: this.url
      });
      window.open(this.url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-mobile {
  position: relative;
  width: 100%;
  &__image {
    width: 100%;
  }
  &__anchor {
    position: absolute;
    width: calc(211px * 0.7);
    height: calc(45px * 0.7);
    border-radius: 4px;
    line-height: calc(48px * 0.7);
    font-size: 15px;
    background-color: #fd312e;
    color: #fff;
    text-align: center;
    left: calc(((20 / 720) * 100) * 1vw);
    bottom: calc(((20 / 720) * 100) * 1vw);
    cursor: pointer;
  }
}
.banner-pc {
  position: relative;
  width: 250px;
  height: 157px;
  &__anchor {
    display: block;
    height: 100%;
    cursor: pointer;
  }
  &__image {
    width: 100%;
  }
  &__text {
    background-color: rgba(34, 29, 29, 0.6);
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    // height: 47px;
    color: #fff;
    padding: 10px 12px 10px;
    box-sizing: border-box;
    @media only screen and (max-width: 1080px){
      display: none;
    }
  }
  &__text-head {
    font-size: 14px;
    line-height: 14px;
    // @media only screen and (max-width: 1080px){
    //   font-size: calc(((24 / 720) * 100) * 1vw);
    //   line-height: calc(((24 / 720) * 100) * 1vw);
    //   font-weight: 400;
    // }
  }
  &__text-title {
    font-size: 18px;
    line-height: 18px;
    margin-top: 2px;
    // @media only screen and (max-width: 1080px){
    //   font-size: calc(((36 / 720) * 100) * 1vw);
    //   line-height: calc(((36 / 720) * 100) * 1vw);
    //   margin-top: calc(((16 / 720) * 100) * 1vw);
    //   font-weight: 400;
    // }
  }
}
</style>